import { Outlet } from "react-router-dom";
import landingStyle from "../styles/landing.module.scss";

function Landing() {
  return (
    <div className={landingStyle.landingShell}>
      <div className={landingStyle.landingBackdrop} aria-hidden="true"></div>

      <div className={landingStyle.landingCard}>
        <div className={landingStyle.landingBrand}>MATLIB</div>
        <p className={landingStyle.landingTagline}>Digital Materials Library</p>

        <div className={landingStyle.landingOutlet}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Landing;
